const dynamicColors = () => {
  const r = Math.floor(Math.random() * 255);
  const g = Math.floor(Math.random() * 255);
  const b = Math.floor(Math.random() * 255);

  return `rgb(${r},${g},${b})`;
};

export default {
  pallet: count => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(dynamicColors());
    }
    return colors;
  }
};
